/* Winstreak Vault — image zoom lightbox.
   Any element with [data-vault-zoom="<url>"] opens a fullscreen viewer:
   scroll or pinch to zoom, drag to pan, double-click to toggle, Esc/backdrop to close. */
(function () {
  var overlay, imgEl, hintEl;
  var scale = 1, tx = 0, ty = 0;
  var MIN = 1, MAX = 5;
  var pointers = {};
  var dragStart = null;
  var pinchStart = null;

  function build() {
    overlay = document.createElement('div');
    overlay.className = 'vault-zoom';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Zoomed product image');
    overlay.innerHTML =
      '<img class="vault-zoom__img" alt="" draggable="false">' +
      '<button class="vault-zoom__close" type="button" aria-label="Close">×</button>' +
      '<div class="vault-zoom__ctrls">' +
      '<button type="button" data-z="out" aria-label="Zoom out">−</button>' +
      '<button type="button" data-z="in" aria-label="Zoom in">+</button>' +
      '</div>' +
      '<div class="vault-zoom__hint">Scroll or pinch to zoom · drag to pan</div>';
    document.body.appendChild(overlay);
    imgEl = overlay.querySelector('.vault-zoom__img');
    hintEl = overlay.querySelector('.vault-zoom__hint');

    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    overlay.querySelector('.vault-zoom__close').addEventListener('click', close);
    overlay.querySelectorAll('[data-z]').forEach(function (b) {
      b.addEventListener('click', function () {
        var r = overlay.getBoundingClientRect();
        zoomAt(b.getAttribute('data-z') === 'in' ? 1.5 : 1 / 1.5, r.width / 2, r.height / 2);
      });
    });
    imgEl.addEventListener('wheel', onWheel, { passive: false });
    imgEl.addEventListener('pointerdown', onDown);
    imgEl.addEventListener('pointermove', onPointerMove);
    imgEl.addEventListener('pointerup', onUp);
    imgEl.addEventListener('pointercancel', onUp);
    imgEl.addEventListener('dblclick', function (e) {
      var r = overlay.getBoundingClientRect();
      if (scale > 1.2) reset(); else zoomAt(2.6, e.clientX - r.left, e.clientY - r.top);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
    });
  }

  function apply() {
    imgEl.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
    overlay.classList.toggle('is-zoomed', scale > 1.01);
    if (hintEl) hintEl.style.opacity = scale > 1.01 ? '0' : '';
  }
  function reset() { scale = 1; tx = 0; ty = 0; apply(); }

  // Zoom toward point (px,py) in overlay coordinates. Image is flex-centered,
  // so its center sits at the overlay center C; keep the point under the cursor fixed.
  function zoomAt(factor, px, py) {
    var r = overlay.getBoundingClientRect();
    var cx = r.width / 2, cy = r.height / 2;
    var ns = Math.min(MAX, Math.max(MIN, scale * factor));
    var ratio = ns / scale;
    tx = (px - cx) * (1 - ratio) + ratio * tx;
    ty = (py - cy) * (1 - ratio) + ratio * ty;
    scale = ns;
    if (scale <= MIN + 0.001) { tx = 0; ty = 0; }
    apply();
  }

  function onWheel(e) {
    e.preventDefault();
    var r = overlay.getBoundingClientRect();
    zoomAt(e.deltaY < 0 ? 1.12 : 1 / 1.12, e.clientX - r.left, e.clientY - r.top);
  }

  function onDown(e) {
    imgEl.setPointerCapture(e.pointerId);
    pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
    var ids = Object.keys(pointers);
    if (ids.length === 1) {
      dragStart = { x: e.clientX, y: e.clientY, tx: tx, ty: ty };
    } else if (ids.length === 2) {
      pinchStart = pinchState();
      dragStart = null;
    }
  }
  function onPointerMove(e) {
    if (!pointers[e.pointerId]) return;
    pointers[e.pointerId] = { x: e.clientX, y: e.clientY };
    var ids = Object.keys(pointers);
    if (ids.length >= 2 && pinchStart) {
      var now = pinchState();
      var r = overlay.getBoundingClientRect();
      zoomAt(now.dist / pinchStart.dist, now.mx - r.left, now.my - r.top);
      tx += now.mx - pinchStart.mx;
      ty += now.my - pinchStart.my;
      apply();
      pinchStart = now;
    } else if (ids.length === 1 && dragStart && scale > 1.01) {
      tx = dragStart.tx + (e.clientX - dragStart.x);
      ty = dragStart.ty + (e.clientY - dragStart.y);
      apply();
    }
  }
  function onUp(e) {
    delete pointers[e.pointerId];
    var ids = Object.keys(pointers);
    if (ids.length < 2) pinchStart = null;
    if (ids.length === 0) dragStart = null;
    else dragStart = { x: pointers[ids[0]].x, y: pointers[ids[0]].y, tx: tx, ty: ty };
  }
  function pinchState() {
    var ids = Object.keys(pointers);
    var a = pointers[ids[0]], b = pointers[ids[1]];
    return { dist: Math.hypot(a.x - b.x, a.y - b.y) || 1, mx: (a.x + b.x) / 2, my: (a.y + b.y) / 2 };
  }

  function open(src, alt) {
    if (!overlay) build();
    reset();
    imgEl.src = src;
    imgEl.alt = alt || '';
    overlay.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }
  function close() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    pointers = {}; dragStart = null; pinchStart = null;
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-vault-zoom]') : null;
    if (!t) return;
    e.preventDefault();
    open(t.getAttribute('data-vault-zoom'), t.getAttribute('alt'));
  });
})();
